export interface CouponData {
  couponCode?: string;
  site?: string;
  error?: any;
}
export interface MessageStructure {
  message?: 'copyAndGo' | 'getToken' | 'dismissWebview';
  payload?: CouponData;
}

export const sendDataToiOS = (data?: MessageStructure) => {
  if ((window as any)?.webkit) {
    (window as any)?.webkit?.messageHandlers?.messageHandlerForiOS?.postMessage(
      data
    );
  } else {
    console.log('iOS message handlers not available.');
  }
};
